export default __webpack_public_path__ + "static/media/omnes_light-webfont.da99f079.svg";